import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ParameterReducer(state = initialState.parameterContent, action: any) {
  switch (action.type) {
    case types.SAVE_PARAMETERCONTENT_SUCCESS:
      return action.parameterContent;
    default:
      return state;
  }
}
